let tempScoreArr = [];

let counter = 17;

export const bestBallCal = (
    array,
    setTeamScoreSystem,
    setPlayersInOutScore,
    setOpen,
    setWinnerTeam,
    parIndexVal,
    handiCapDiff
) => {
    // 1 Point Match Scenerio
    let tempGroupArr = [...array.group1, ...array.group2];

    let [t1, t2, t3, t4] = tempGroupArr;

    tempScoreArr = [];
    counter = 17;

    for (let i = 0; i <= counter; i++) {
        if (
            t1[i].score > 0 &&
            t2[i].score > 0 &&
            t3[i].score > 0 &&
            t4[i].score > 0
        ) {
            let tempBpArr = [t1[i], t2[i], t3[i], t4[i]];

            calculateScore(
                tempBpArr,
                i,
                setTeamScoreSystem,
                array,
                setPlayersInOutScore,
                setOpen,
                setWinnerTeam,
                parIndexVal,
                handiCapDiff
            );
        }
    }
};

const calculateScore = (
    bpArr,
    index,
    setTeamScoreSystem,
    array,
    setPlayersInOutScore,
    setOpen,
    setWinnerTeam,
    parIndexVal,
    handiCapDiff
) => {
    let tempBpArr = [...bpArr];

    // Check advantage point
    for (let i = 0; i < tempBpArr.length; i++) {
        if (tempBpArr[i].advantage) {
            let score = tempBpArr[i].score - 1;
            tempBpArr[i] = {score: score};
        }
    }

    let team1Lowest = tempBpArr[0];
    let team2Lowest = tempBpArr[2];

    // Both Teams Best Game Cal
    for (let i = 0; i < tempBpArr.length; i++) {
        if (i < 2) {
            if (tempBpArr[i].score < team1Lowest.score) {
                team1Lowest = tempBpArr[i];
            }
        } else {
            if (tempBpArr[i].score < team2Lowest.score) {
                team2Lowest = tempBpArr[i];
            }
        }
    }

    let statusBestGame;

    let holePoints = 0;
    let label;

    // Best Game check
    if (team1Lowest.score === team2Lowest.score) {
        statusBestGame = "tie";
    } else if (team1Lowest.score < team2Lowest.score) {
        holePoints = holePoints + 1;
        statusBestGame = "group1";
    } else {
        holePoints = holePoints + 1;
        statusBestGame = "group2";
    }

    if (statusBestGame === "tie") {
        label = "tie";
    } else if (statusBestGame === "group1") {
        label = "group1";
    } else {
        label = "group2";
    }

    // Assigning Score Points Cal
    let tempObj = {};
    if (index === 0) {
        // If 1st Hole Tie
        if (label === "tie") {
            tempObj = {
                count: 0,
                label: "tie",
            };
        } else {
            tempObj = {
                count: holePoints,
                label: label,
            };
        }
    } else {
        // Checking from 2nd Hole
        if (label === "tie") {
            tempObj = tempScoreArr[index - 1];
        } else if (label === tempScoreArr[index - 1].label) {
            // if previous and current whole winner same
            let score = tempScoreArr[index - 1].count + holePoints;
            tempObj = {
                count: score,
                label: label,
            };
        } else {
            // If hole winner change
            if (tempScoreArr[index - 1].count === 1 && holePoints === 2) {
                tempObj = {
                    count: 1,
                    label: label,
                };
            } else if (tempScoreArr[index - 1].count === holePoints) {
                tempObj = {
                    count: 0,
                    label: "tie",
                };
            } else if (tempScoreArr[index - 1].count > 2) {
                let score = tempScoreArr[index - 1].count - holePoints;
                tempObj = {
                    count: score,
                    label: tempScoreArr[index - 1].label,
                };
            } else {
                tempObj = {
                    count: holePoints,
                    label: label,
                };
            }
        }
    }

    tempScoreArr.push(tempObj);

    if (index >= 9) {
        if (tempScoreArr[index].count > 17 - index) {
            // autoHoleFilling(
            //   index,
            //   array,
            //   setPlayersInOutScore,
            //   tempScoreArr,
            //   parIndexVal,
            //   handiCapDiff
            // );

            tempScoreArr[index] = {
                ...tempScoreArr[index],
                count: `${tempScoreArr[index].count}&${17 - index}`,
            };

            setWinnerTeam((pre) => {
                return {
                    ...pre,
                    sudden_death: false,
                    score_up_group: tempScoreArr[index].label,
                    won: tempScoreArr[index].label,
                    autoScoreHoles: `${tempScoreArr[index].count}`,
                    score_up: true,
                    score_up_value: `${tempScoreArr[index].count}UP`,
                };
            });
            counter = index;
        } else if (index === 17) {
            if (tempScoreArr[index].count === 0) {
                setOpen(true);
            }
        }
    } else {
        setTeamScoreSystem([]);
        setTeamScoreSystem(tempScoreArr);
    }
};
